"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Paragraph = _interopRequireDefault(require("../Paragraph/Paragraph"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CommentText = function CommentText(_ref) {
  var authorName = _ref.authorName,
      children = _ref.children;
  return (0, _themeUi.jsx)("div", {
    sx: {
      p: 1
    }
  }, (0, _themeUi.jsx)(_Paragraph["default"], {
    sx: {
      whiteSpace: 'pre-line',
      m: 0
    }
  }, (0, _themeUi.jsx)("strong", {
    sx: {
      mr: 3
    }
  }, authorName), children));
};

CommentText.propTypes = {
  authorName: _propTypes["default"].string,
  children: _propTypes["default"].node
};
var _default = CommentText;
exports["default"] = _default;